import React from "react";
import EditIcon from "../../../../assets/svgs/Edit.jsx";

const SalaryDetails = () => {
  return (
    <div className="rounded-lg shadow-xl flex flex-col py-5 mb-10 text-sm sm:text-base">
      <div className="flex justify-between py-4 px-5 md:px-9 border-b text-base sm:text-lg">
        <p className="text-lg font-semibold">Professional Details</p>
        <button className="flex space-x-1">
          <EditIcon />
          <span>Edit Info</span>
        </button>
      </div>

      <div className="space-y-4 px-9 py-5">
        <div>
          <h3 className="font-medium">Current Job Title</h3>
          <p className="text-xs">UI/UX Designer</p>
        </div>
        <div>
          <h3 className="font-medium">Gross Salary</h3>
          <p className="text-xs">USD 3.000</p>
        </div>
        <div>
          <h3 className="font-medium">Currency</h3>
          <p className="text-xs">USD</p>
        </div>
      </div>
    </div>
  );
};

export default SalaryDetails;
